import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=c3ee47b2&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=c3ee47b2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ee47b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ee47b2')) {
      api.createRecord('c3ee47b2', component.options)
    } else {
      api.reload('c3ee47b2', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=c3ee47b2&scoped=true&", function () {
      api.rerender('c3ee47b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nRyPRVnqk2kE/JS/comp/Paginate.vue"
export default component.exports